import { protectWithAccountPermissions } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { PlanManagementPage } from 'features/planManagement'
import { canViewBillingPermission } from 'hooks/usePermission'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/plan/unpaid-invoices')({
  component: PlanManagementPage,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Plan & Usage'),
      },
    ],
  }),
  beforeLoad: protectWithAccountPermissions(canViewBillingPermission),
})
